import { ErrorMessage, useField } from "formik";
import "./InputField.scss";

const TextAreaField = ({ name, label, required, ...props }: any) => {
  const [field, meta] = useField(name);
  return (
    <div className="Input-Field">
      <label className="Field-Label" htmlFor={field.name}>
        {label}
        {required === true ? (
          <label className="Field-Label-Red">&nbsp;*</label>
        ) : (
          ""
        )}
      </label>
      <textarea
        maxLength={props.maxLength ? props.maxLength : 100}
        autoComplete={name} //TODO CHECK
        {...field}
        {...props}
      />
      <ErrorMessage
        name={field.name}
        component="label"
        className="Field-Error"
      />
    </div>
  );
};
export default TextAreaField;
